class RootMtProtoStore {
    static createStore() {
        return new RootMtProtoStore();
    }
}

export const rootMtProtoStore = RootMtProtoStore.createStore();
